import React from 'react';
import PoseCard from './PoseCard';
import poseData from '../data/poses.json';
import './PoseList.css';

const PoseList = ({ currentPose, loadingPose, selectedPose, onPoseSelect }) => {
  return (
    <div className="pose-list">
      <div className="pose-list-header">
        <h2>Infinite Asana Loops</h2>
        <p>Touch any pose to play its accompanying music</p>
      </div>
      <div className="poses-container">
        {poseData.map((pose) => (
          <PoseCard
            key={pose.Number}
            pose={pose}
            isActive={currentPose === pose.Number}
            isSelected={selectedPose === pose.Number}
            isLoading={loadingPose === pose.Number}
            onSelect={() => onPoseSelect(pose.Number)}
          />
        ))}
      </div>
    </div>
  );
};

export default PoseList;
